export function initFooter() {
    console.log('Footer initialized!')
}
